import React, { useState, useEffect, useRef } from "react";
import { X, Download } from "lucide-react";
import styles from "./PwaInstallBanner.module.css";

interface BeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
}

const DISMISS_KEY = "kenometric_pwa_dismissed";

export const PwaInstallBanner: React.FC = () => {
  const [show, setShow] = useState(false);
  const deferredPrompt = useRef<BeforeInstallPromptEvent | null>(null);

  useEffect(() => {
    try { if (localStorage.getItem(DISMISS_KEY)) return; } catch { return; }

    const handler = (e: Event) => {
      e.preventDefault();
      deferredPrompt.current = e as BeforeInstallPromptEvent;
      setShow(true);
    };

    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt.current) return;
    await deferredPrompt.current.prompt();
    const { outcome } = await deferredPrompt.current.userChoice;
    if (outcome === "accepted") {
      setShow(false);
    }
    deferredPrompt.current = null;
  };

  const handleDismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch { /* localStorage blocked */ }
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <Download size={20} className={styles.icon} />
        <span className={styles.text}>Installer KenoMetric</span>
      </div>
      <div className={styles.actions}>
        <button className={styles.installBtn} onClick={handleInstall}>
          Installer
        </button>
        <button
          className={styles.closeBtn}
          onClick={handleDismiss}
          aria-label="Fermer"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
};
